// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Ph2v","title":"ClientInsurance_title___CZI_","itemText":"ClientInsurance_itemText__Nwt2X"};